<template>
  <ChartLibraryChart
    :chart-config="chartConfig"
    :chart-data="chartData"
    data-testid="outreach-contact-recent-articles-mention-volume"
    :loading="loading"
  />
</template>

<script>
import StreamFilters from "shared/helpers/StreamFilters";
import ChartLibraryChart from "shared/modules/Charts/components/ChartLibraryChart/ChartLibraryChart.vue";

export default {
  name: "OutreachContactRecentArticlesMentionVolume",
  components: {
    ChartLibraryChart,
  },
  props: {
    stream: {
      type: Object,
      required: true,
    },
    filters: {
      type: StreamFilters,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      chartConfig: {
        component: "CoverageVolumeTimeline",
        method: "coverage_volume_timeline",
        options: {
          showTitle: false,
          hideLegend: true,
        },
        chartOptions: {
          scales: {
            x: {
              grid: {
                display: true,
                drawTicks: false,
                color: "#D4DAE0",
              },
              ticks: {
                display: false,
              },
            },
            volume: {
              ticks: {
                display: false,
              },
              grid: {
                display: false,
              },
              display: false,
            },
          },
        },
        style: {
          height: "110px",
        },
      },
      chartData: {},
    };
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.loadData();
      },
    },
    stream: {
      deep: true,
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const requestParams = this.filters.requestFilters();

        const params = {
          after: requestParams.range.after,
          before: requestParams.range.before,
          keyword: this.stream.keyword,
        };

        const { data } = await this.$streemApiV1.post(
          `influencers/${this.stream.influencer_id}/recent_articles_histogram`,
          {
            params,
          }
        );

        this.chartData = {
          data,
          options: {
            ...this.chartConfig.chartOptions,
          },
        };
      } catch (error) {
        this.$error(
          this.$t(
            "outreach_contact_recent_articles_mention_volume.load_errror"
          ),
          error
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
